import { NotificationSettings, usePutApiNotificationSettingsDelete, usePutApiNotificationSettingsUpdate, getGetApiNotificationSettingsListQueryKey, postApiNotificationSettingsExport, postApiNotificationSettingsTest } from "@/API";
import { ActionIcon, Badge, Button, Group, Paper, Text } from "@mantine/core";
import { IconEdit, IconFileExport, IconFlask, IconTrash, IconUserCog } from "@tabler/icons-react";
import { useQueryClient } from "@tanstack/react-query";
import { notifications } from "@mantine/notifications";
import { useNavigate } from "@tanstack/react-router";
import { modals } from "@mantine/modals";
import { TextSaveToFile } from "@/Helpers/SaveToFile";
import { NotificationSettingsEditButton } from "./NotificationSettingsEditButton";
import { LineNotificationRegisterButton } from "./Line/LineNotificationRegisterButton";
import { useState } from "react";

export function NotificationSettingsCard(props: { data: NotificationSettings }) {
    const queryClient = useQueryClient()
    const navigate = useNavigate()
    const update_Mutation = usePutApiNotificationSettingsUpdate()
    const delete_Mutation = usePutApiNotificationSettingsDelete()
    const [loading, setLoading] = useState(false)

    return <>
        <Paper pos="relative" shadow="xs" p="sm" withBorder w={350}>
            <Group pos="absolute" right={5} top={5} gap={0}>
                <ActionIcon variant="subtle" onClick={async () => {
                    var exportData = await postApiNotificationSettingsExport({ workspaceId: props.data.workspaceId, id: props.data.id })
                    TextSaveToFile(`${exportData.data.name}.json`, JSON.stringify(exportData.data))
                }}>
                    <IconFileExport style={{ width: '70%', height: '70%' }} stroke={1.5} />
                </ActionIcon>

                <NotificationSettingsEditButton workspaceId={props.data.workspaceId ?? ""} type={props.data.type ?? "None"} initValue={props.data} onChange={async v => {
                    try {
                        await update_Mutation.mutateAsync({ params: { workspaceId: props.data.workspaceId }, data: v })
                        queryClient.invalidateQueries({ queryKey: getGetApiNotificationSettingsListQueryKey({ workspaceId: props.data.workspaceId }) })
                        notifications.show({ message: "更新成功" })
                    } catch (e) {
                        notifications.show({ message: "更新失敗", color: "red" })
                    }
                }}>
                    <ActionIcon variant="subtle" >
                        <IconEdit style={{ width: '70%', height: '70%' }} stroke={1.5} />
                    </ActionIcon>
                </NotificationSettingsEditButton>

                <ActionIcon variant="subtle" color="red" onClick={async () => {
                    modals.openContextModal({
                        modal: "ConfirmCountDown",
                        title: '刪除',
                        innerProps: {
                            countDownSecond: 1,
                            children: (
                                <Text size="sm">
                                    是否要刪除"{props.data.name}"?
                                </Text>
                            ),
                            labels: {
                                confirm: '刪除', cancel: '取消'
                            },
                            confirmProps: { color: 'red' },
                            onConfirm: async () => {
                                try {
                                    await delete_Mutation.mutateAsync({
                                        params: {
                                            workspaceId: props.data.workspaceId,
                                            id: props.data.id
                                        }
                                    })
                                    queryClient.invalidateQueries({ queryKey: getGetApiNotificationSettingsListQueryKey({ workspaceId: props.data.workspaceId }) })
                                    notifications.show({ message: "刪除成功" })
                                } catch (e) {
                                    notifications.show({ message: "刪除失敗", color: "red" })
                                }
                            },
                        },

                    });
                }}>
                    <IconTrash style={{ width: '70%', height: '70%' }} stroke={1.5} />
                </ActionIcon>
            </Group>
            <Badge>
                {props.data.type}
            </Badge>
            <Text fw={600} size="lg">{props.data.name}</Text>
            <Group justify="end" mt="md">
                {props.data.type == "Line" && props.data.workspaceId && props.data.id && <LineNotificationRegisterButton workspaceId={props.data.workspaceId} id={props.data.id}>
                    <Button leftSection={<IconUserCog />}>註冊發送對象</Button>
                </LineNotificationRegisterButton>}
                <Button loading={loading} leftSection={<IconFlask />} onClick={() => {
                    modals.openContextModal({
                        modal: "Textarea",
                        title: "通知測試",
                        innerProps: {
                            textareaProps: {
                                label: "測試訊息"
                            },
                            onConfirm: async v => {
                                setLoading(true)
                                try {
                                    await postApiNotificationSettingsTest(JSON.stringify(v), {
                                        workspaceId: props.data.workspaceId,
                                        id: props.data.id
                                    }, { headers: { "Content-Type": "application/json" } })
                                    notifications.show({ message: "傳送成功" })
                                } catch (e) {
                                    notifications.show({ message: "傳送失敗", color: "red" })
                                }
                                setLoading(false)
                            }
                        }
                    })
                }}>
                    測試
                </Button>
            </Group>
        </Paper >
    </>
}